import produce from 'immer';

// import { StateListType } from './../../../types/state-list-type';
import { IReduxAction } from '../../../services/interfaces/common-interface';
import {
  GET_ALL_SUCCESS,
  GET_BY_ID_SUCCESS,
  SEARCH,
  SET_LOADING_SEND,
  SET_LOADING_DATA,
  SET_PAGE,
  SET_ROWS_PER_PAGE,
  SET_ORDER,
  SET_ORDERBY,
  DELETE_DEVICE_SUCCESS,
  UPDATE_DEVICE_SUCCESS
} from './user-constants';

const INITIAL_STATE: any = {
  loadingData: true,
  loadingSend: false,
  form: {
    data: null,
    errors: [],
    selects: null
  },
  list: {
    allRows: [],
    rows: [],
    rowsCount: 0,
    page: 0,
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 25, 50, 100],
    selected: [],
    selectedCount: 0,
    order: 'asc',
    orderBy: 'name'
  }
};

const usersReducer = (state: any = { ...INITIAL_STATE }, action: IReduxAction) => {
  switch (action.type) {
    case SET_LOADING_DATA: {
      return {
        ...state,
        loadingData: action.loading
      };
    }

    case SET_LOADING_SEND: {
      return {
        ...state,
        loadingSend: action.loading
      };
    }

    case GET_ALL_SUCCESS: {
      return {
        ...state,
        list: {
          ...INITIAL_STATE.list,
          rows: action.payload,
          allRows: action.payload
        }
      };
    }

    case SEARCH: {
      const { queryText, filters } = action;
      let results =
        queryText && queryText !== ''
          ? [
              ...state?.list?.allRows?.filter(
                (item: any) =>
                  item?.name?.toLowerCase().startsWith(queryText?.toLowerCase()) ||
                  item?.name?.toLowerCase().includes(queryText?.toLowerCase()) ||
                  item?.email?.toLowerCase().toString().startsWith(queryText?.toLowerCase()) ||
                  item?.externalCode?.toString()?.startsWith(queryText)
              )
            ]
          : [...state?.list?.allRows];

      if (filters?.userRoleSelecteds) {
        results = [...results.filter(x => filters?.userRoleSelecteds?.includes(x.userRole))];
      }

      if (filters?.inactive !== 'all') {
        results = [...results?.filter(x => x.inactive === (filters?.inactive === 'inactive'))];
      }

      return {
        ...state,
        list: {
          ...state.list,
          rows: [...results],
          queryText,
          filters
        }
      };
    }

    case GET_BY_ID_SUCCESS: {
      return {
        ...state,
        form: {
          ...action.payload
        }
      };
    }

    case UPDATE_DEVICE_SUCCESS: {
      const devices: any = produce(state.form.data.devices, draft => {
        const itemIndex = draft.findIndex(d => d._id === action.device._id);
        if (itemIndex >= 0) {
          draft[itemIndex] = { ...action.device };
        }
      });

      return {
        ...state,
        form: {
          ...state.form,
          data: {
            ...state.form.data,
            devices: [...devices]
          }
        }
      };
    }

    case DELETE_DEVICE_SUCCESS: {
      const devices: any = produce(state.form.data.devices, draft => {
        const itemIndex = draft.findIndex(d => d._id === action.deviceId);
        if (itemIndex >= 0) {
          draft.splice(itemIndex, 1);
        }
      });

      return {
        ...state,
        form: {
          ...state.form,
          data: {
            ...state.form.data,
            devices: [...devices]
          }
        }
      };
    }

    case SET_PAGE: {
      return {
        ...state,
        list: {
          ...state.list,
          page: action.page
        }
      };
    }

    case SET_ROWS_PER_PAGE: {
      return {
        ...state,
        list: {
          ...state.list,
          rowsPerPage: action.rowsPerPage
        }
      };
    }

    case SET_ORDER: {
      return {
        ...state,
        list: {
          ...state.list,
          order: action.order
        }
      };
    }

    case SET_ORDERBY: {
      return {
        ...state,
        list: {
          ...state.list,
          orderBy: action.orderBy
        }
      };
    }

    default:
      return state;
  }
};

export default usersReducer;
